import React, { useState } from "react";
import { toast } from "react-toastify";
import { useGetBankInfosQuery } from "../../../features/api/bankinfoApi";
import { useAddDepositInfoMutation } from "../../../features/api/depositApi";

const CreateBankDeposit = () => {
  const { data, error, isLoading } = useGetBankInfosQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const bankInfos = data?.bankinfos;

  const [addNewDepositInfo] = useAddDepositInfoMutation();

  const [accName, setAccName] = useState("");
  const [accNo, setAccNo] = useState("");
  const [depositAmt, setDepositAmt] = useState("");
  const [depositStatus, setDepositStatus] = useState("");
  const [dealer, setDealer] = useState("");
  const [supplier, setSupplier] = useState("");
  const [clearingDate, setClearingDate] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const saveData = {
      accName,
      accNo,
      depositAmt,
      depositStatus,
      dealer,
      supplier,
      clearingDate,
    };
    try {
      const result = await addNewDepositInfo(saveData);
      if (result) {
        toast.success("Added Successful...!!!");
        setAccName("");
        setAccNo("");
        setDepositAmt("");
        setDepositStatus("");
        setDealer("");
        setSupplier("");
        setClearingDate("");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
  return (
    <div className="w-full max-w-[1280px] mx-auto p-6 md:px-auto h-[90vh] overflow-auto">
      <h1 className="uppercase font-bold">create bank Deposit</h1>
      <div className="py-4">
        <form className="">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            <div>
              <label>Account Name: </label>
              {/* <input
                type="text"
                onChange={(e) => setAccName(e.target.value)}
                className="border h-8 rounded w-full p-1 focus:outline-none"
              /> */}
              <select
                onChange={(e) => setAccName(e.target.value)}
                className="border h-8 rounded w-full p-1 focus:outline-none"
              >
                <option>--select--</option>
                {bankInfos?.map((bank) => (
                  <option value={bank?.accName}>{bank?.accName}</option>
                ))}
              </select>
            </div>
            <div>
              <label>Account No.: </label>
              {/* <input
                type="text"
                onChange={(e) => setAccNo(e.target.value)}
                className="border h-8 rounded w-full p-1 focus:outline-none"
              /> */}
              <select
                onChange={(e) => setAccNo(e.target.value)}
                className="border h-8 rounded w-full p-1 focus:outline-none"
              >
                <option>--select--</option>
                {bankInfos?.map((bank) => (
                  <option value={bank?.accNo}>{bank?.accNo}</option>
                ))}
              </select>
            </div>
            <div>
              <label>Deposit Amount: </label>
              <input
                type="text"
                value={depositAmt}
                onChange={(e) => setDepositAmt(e.target.value)}
                className="border h-8 rounded w-full p-1 focus:outline-none"
              />
            </div>
            <div>
              <label>Deposit Status: </label>
              <input
                type="text"
                value={depositStatus}
                onChange={(e) => setDepositStatus(e.target.value)}
                className="border h-8 rounded w-full p-1 focus:outline-none"
              />
            </div>

            <div>
              <label>Dealer: </label>
              <input
                type="text"
                value={dealer}
                onChange={(e) => setDealer(e.target.value)}
                className="border h-8 rounded w-full p-1 focus:outline-none"
              />
            </div>
            <div>
              <label>Supplier: </label>
              <input
                type="text"
                value={supplier}
                onChange={(e) => setSupplier(e.target.value)}
                className="border h-8 rounded w-full p-1 focus:outline-none"
              />
            </div>
            <div>
              <label>Clearing Date: </label>
              <input
                type="date"
                value={clearingDate}
                onChange={(e) => setClearingDate(e.target.value)}
                className="border h-8 rounded w-full p-1 focus:outline-none"
              />
            </div>
          </div>
          <button
            onClick={handleSubmit}
            className="px-2 py-1 bg-green-500 text-white font-bold rounded mt-4"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateBankDeposit;